const INS_BASE_URL = "https://i.instagram.com";
export const LOG_ATTRIBUTION =
  INS_BASE_URL + "/api/v1/attribution/log_attribution/";
export const LANUCH_MOBILE_CONFIG =
  INS_BASE_URL + "/api/v1/launcher/mobileconfig/";
export const INS_LGOIN = INS_BASE_URL + "/api/v1/accounts/login/";

export const USER_INFO_BY_ID = (userId: string) =>
  INS_BASE_URL + `/api/v1/users/${userId}/info/`;
export const USER_INFO_BY_USERNAME = (username: string) =>
  INS_BASE_URL + `/api/v1/users/${username}/usernameinfo/`;

export const INS_USER_SEARCH = INS_BASE_URL + "/api/v1/users/search/";
export const ACCOUNT_SET_PUBLIC = INS_BASE_URL + "/api/v1/accounts/set_public/";
export const SET_COMMENT_CONTROL =
  INS_BASE_URL + "/api/v1/accounts/set_comment_audience_control_type/";

export const FRENDSHIP_CREATE = (userId: string) =>
  INS_BASE_URL + `/api/v1/friendships/create/${userId}/`;
export const GET_FEED_BY_USER_ID = (userId: string) =>
  INS_BASE_URL + `/api/v1/feed/user/${userId}/`;
export const GET_FEED_BY_USERNAME = (username: string) =>
  INS_BASE_URL + `/api/v1/feed/user/${username}/username/`;
export const GET_MEDIA_INFO_BY_ID = (mediaId: string) =>
  INS_BASE_URL + `/api/v1/media/${mediaId}/info/`;
export const ENABLED_COMMNETS = (mediaId: string) =>
  INS_BASE_URL + `/api/v1/media/${mediaId}/enable_comments/`;
export const MEDIA_LIKE = (mediaId: string) =>
  INS_BASE_URL + `/api/v1/media/${mediaId}/like/`;

export const COMMENT_OFFENSIVE =
  INS_BASE_URL + "/api/v1/media/comment/check_offensive_comment/";
export const MEDIA_COMMENT = (mediaId: string) =>
  INS_BASE_URL + `/api/v1/media/${mediaId}/comment/`;

export const LOGIN_WITH_TWO_FACTORURL =
  INS_BASE_URL + `/api/v1/accounts/two_factor_login/`;
export const SEND_TWOFACTOR_LOGINSMS_URL =
  INS_BASE_URL + `/api/v1/accounts/send_two_factor_login_sms/`;

export const ACCOUNT_CURRENT_USER =
  INS_BASE_URL + "/api/v1/accounts/current_user/";

export const RUPLOAD_IGPHOTO = (uuid: string) =>
  INS_BASE_URL + `/rupload_igphoto/${uuid}`;

export const EDIT_PROFILE = INS_BASE_URL + "/api/v1/accounts/edit_profile/";
export const MEDIA_CONFIGURE = INS_BASE_URL + "/api/v1/media/configure/";
export const FIXCAL_SSO_ACCOUNT =
  INS_BASE_URL + "/api/v1/fxcal/get_sso_accounts/";
export const FIXCAL_SSO_LOGIN = INS_BASE_URL + "/api/v1/fxcal/sso_login/";

export const GET_CHALLENG_PATH = (path: string = "challenge/") =>
  INS_BASE_URL + `/api/v1${path}`;
export const CHALLENGE_BLOKS_APPS = (bloksAction: string) =>
  INS_BASE_URL + `/api/v1/bloks/apps/${bloksAction}/`;
